import env from './env';

const REFILLS_CATEGORY = {
  dev: 34,
  prod: 334,
};

const BOOST_CATEGORY = {
  dev: 47,
  prod: 460,
};

export const SUBSCRIPTIONS_FILTERS = {
  newlyAdded: [
    {
      section: 'For You',
      ids: [3],
    },
    {
      section: 'Featured Shop',
      ids: [REFILLS_CATEGORY[env.appEnv]],
    },
  ],
};

export const BOOST_FILTERS = {
  fffPicks: [
    {
      section: 'Featured Shop',
      ids: [BOOST_CATEGORY[env.appEnv]],
    },
  ],
};

export const BOOSTS_PATH = {
  q1: '/boosts-q1',
  q2: '/boosts-q2',
};

export const PROGRESS_BAR_ITEMS = ['Customize', 'Boost Your Box', 'Add-Ons'];
